<template>
    <va-edit-layout>
        <RetrochargeEventTaxWithheldCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></RetrochargeEventTaxWithheldCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
